import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
// import './CategoryPage.css'; // Ensure you have the CSS file imported
// H


import img1 from '../../img/Bathroom Accessories/1.png';
import img34 from '../../img/Bathroom Accessories/baby bath tub blue (4).png';
import img35 from '../../img/Bathroom Accessories/baby bath tub brown (2).png';
import img36 from '../../img/Bathroom Accessories/baby bath tub green (1).png';
import img37 from '../../img/Bathroom Accessories/baby bath tub orange (2).png';
import img39 from '../../img/Bathroom Accessories/Bathroom set new design 2021/blue bathstool (1).png';
import img40 from '../../img/Bathroom Accessories/Bathroom set new design 2021/blue bucket (1).png';
import img41 from '../../img/Bathroom Accessories/Bathroom set new design 2021/blue pedalbin (2).png';
import img42 from '../../img/Bathroom Accessories/Bathroom set new design 2021/Blue set 6pcs.png';
import img43 from '../../img/Bathroom Accessories/Bathroom set new design 2021/Blue set.png';
import img44 from '../../img/Bathroom Accessories/Bathroom set new design 2021/pink bathstool (2).png';
import img45 from '../../img/Bathroom Accessories/Bathroom set new design 2021/pink bucket (2).png';
import img46 from '../../img/Bathroom Accessories/Bathroom set new design 2021/pink pedalbin (3).png';
import img47 from '../../img/Bathroom Accessories/Bathroom set new design 2021/Pink set 6pcs.png';
import img48 from '../../img/Bathroom Accessories/Bathroom set new design 2021/Pink set.png';
import img49 from '../../img/Bathroom Accessories/Bathroom set new design 2021/printed mug  (2).png';
import img50 from '../../img/Bathroom Accessories/Bathroom set new design 2021/printed supertubs (1).png';
import img51 from '../../img/Bathroom Accessories/Bathroom set new design 2021/Soapcase.png';
import img52 from '../../img/Bathroom Accessories/Bathroom set new design 2021/yellow bathstool (5).png';

import img53 from '../../img/Bathroom Accessories/Bathroom set new design 2021/yellow bucket (5).png';
import img54 from '../../img/Bathroom Accessories/Bathroom set new design 2021/yellow pedalbin (2).png';

import img55 from '../../img/Bathroom Accessories/Bathroom set new design 2021/Yellow set 6pcs.png';

import img56 from '../../img/Bathroom Accessories/Bathroom set new design 2021/Yellow set.png';
import img26 from '../../img/Bathroom Accessories/blue (2) 54.png';
import img27 from '../../img/Bathroom Accessories/brown (2) 55.png';

import img4 from '../../img/Bathroom Accessories/bucket2.png';
import img11 from '../../img/Bathroom Accessories/close handle mugs (36).png';
import img12 from '../../img/Bathroom Accessories/close handle mugs (38).png';
import img23 from '../../img/Bathroom Accessories/Copy of GOLD BUCKET (20).png';
import img17 from '../../img/Bathroom Accessories/Copy of GOLD BUCKET (21).png';
import img18 from '../../img/Bathroom Accessories/Copy of GOLD BUCKET (22).png';
import img19 from '../../img/Bathroom Accessories/Copy of GOLD BUCKET (23).png';
import img13 from '../../img/Bathroom Accessories/DC MUGS (4).png';
import img14 from '../../img/Bathroom Accessories/DC MUGS 3.png';
import img15 from '../../img/Bathroom Accessories/DUPLEX MUGS (33).png';

import img5 from '../../img/Bathroom Accessories/GOLD BUCKET (24).png';

import img28 from '../../img/Bathroom Accessories/ivory 2 52.png';

import img3 from '../../img/Bathroom Accessories/LB BUCKET (10).png';

import img24 from '../../img/Bathroom Accessories/LB BUCKET (11).png';
import img2 from '../../img/Bathroom Accessories/LB BUCKET (8).png';

import img20 from '../../img/Bathroom Accessories/LB BUCKET (9).png';
import img10 from '../../img/Bathroom Accessories/LB LID Bucket 13.png';
import img9 from '../../img/Bathroom Accessories/LB LID Bucket_orange 12.png';
import img29 from '../../img/Bathroom Accessories/Pearl black (2) 56.png';
import img30 from '../../img/Bathroom Accessories/pink (1) 53.png';
import img22 from '../../img/Bathroom Accessories/square bucket (14).png';
import { default as img25 } from '../../img/Bathroom Accessories/square bucket (15).png';
import img6 from '../../img/Bathroom Accessories/square bucket (16).png';
import img8 from '../../img/Bathroom Accessories/square bucket (18).png';
import img21 from '../../img/Bathroom Accessories/square bucket (19).png';
import img31 from '../../img/Bathroom Accessories/SUPER TUB (49).png';
import img32 from '../../img/Bathroom Accessories/SUPER TUB (50).png';
import img33 from '../../img/Bathroom Accessories/SUPER TUB (51).png';

// new Gardening
import Gimg6 from '../../img/gadening/Copy of hook pot planter (45).png';
import Gimg1 from '../../img/gadening/Copy of hook pot planter (5).png';
import Gimg8 from '../../img/gadening/decor blue (4).png';
import Gimg16 from '../../img/gadening/DSC_2507.png';
import Gimg24 from '../../img/gadening/Vertical Planter_3.png';

// new Pata and Stools
import Pimg1 from '../../img/pata&stool/bath stool (4).png';
import Pimg4 from '../../img/pata&stool/bath stool (7).png';
import Pimg3 from '../../img/pata&stool/bath stool (9).png';
import Pimg2 from '../../img/pata&stool/Bath Stool.png';
import Pimg5 from '../../img/pata&stool/Copy of GAJANI PATA (1).png';
import Pimg6 from '../../img/pata&stool/Copy of GAJANI PATA (4).png';
import Pimg7 from '../../img/pata&stool/Copy of GAJANI PATA (5).png';
import Pimg8 from '../../img/pata&stool/Copy of GAJANI PATA (7).png';
import Pimg32 from '../../img/pata&stool/Copy of KRISH PATA (11).png';
import Pimg9 from '../../img/pata&stool/Copy of KRISH PATA (4).png';
import Pimg31 from '../../img/pata&stool/Copy of KRISH PATA (5).png';
import Pimg10 from '../../img/pata&stool/Copy of KRISH PATA (7).png';
import Pimg12 from '../../img/pata&stool/GAJANI PATA (1).png';
import Pimg11 from '../../img/pata&stool/GAJANI PATA (3).png';
import Pimg13 from '../../img/pata&stool/JUMBO PANDA STOOL (1).png';
import Pimg17 from '../../img/pata&stool/JUMBO PANDA STOOL (3).png';
import Pimg14 from '../../img/pata&stool/JUMBO PANDA STOOL (4).png';
import Pimg15 from '../../img/pata&stool/JUMBO PANDA STOOL (7).png';
import Pimg16 from '../../img/pata&stool/JUMBO PANDA STOOL (8).png';
import Pimg18 from '../../img/pata&stool/krish pata (1).png';
import Pimg19 from '../../img/pata&stool/krish pata (2).png';
import Pimg33 from '../../img/pata&stool/KRISH PATA (3).png';
import Pimg34 from '../../img/pata&stool/KRISH PATA (5).png';
import Pimg20 from '../../img/pata&stool/KRISH PATA (7).png';
import Pimg25 from '../../img/pata&stool/RIO PATA (10).png';
import Pimg21 from '../../img/pata&stool/RIO PATA (2).png';
import Pimg22 from '../../img/pata&stool/RIO PATA (3).png';
import Pimg23 from '../../img/pata&stool/RIO PATA (6).png';
import Pimg24 from '../../img/pata&stool/RIO PATA (7).png';
import Pimg30 from '../../img/pata&stool/SHAKTIMAN PATA (3).png';
import Pimg26 from '../../img/pata&stool/SHAKTIMAN PATA (4).png';
import Pimg27 from '../../img/pata&stool/SHAKTIMAN PATA (5).png';
import Pimg28 from '../../img/pata&stool/SHAKTIMAN PATA (7).png';
import Pimg29 from '../../img/pata&stool/SHAKTIMAN PATA (9).png';



// new Unbreakable Accessories

import Uimg1 from '../../img/unbreakable accessories/_DSC7645 a.png';
import Uimg2 from '../../img/unbreakable accessories/_DSC7646 a.png';
import Uimg3 from '../../img/unbreakable accessories/_DSC7647 a.png';
import Uimg4 from '../../img/unbreakable accessories/_DSC7648 a.png';
import Uimg5 from '../../img/unbreakable accessories/_DSC7650 a.png';
import Uimg6 from '../../img/unbreakable accessories/cement tagari (1).png';
import Uimg7 from '../../img/unbreakable accessories/CONSTRO TAGARI (1).png';
import Uimg9 from '../../img/unbreakable accessories/CONSTRO TAGARI (3).png';
import Uimg8 from '../../img/unbreakable accessories/CONSTRO TAGARI (5).png';
import Uimg12 from '../../img/unbreakable accessories/Copy of GOLD BUCKET (1).png';
import Uimg14 from '../../img/unbreakable accessories/Copy of GOLD BUCKET (2).png';
import Uimg13 from '../../img/unbreakable accessories/Copy of GOLD BUCKET (4).png';
import Uimg10 from '../../img/unbreakable accessories/Copy of GOLD BUCKET (7).png';

import Uimg15 from '../../img/unbreakable accessories/SILVER GHAMELA 1.png';
import Uimg20 from '../../img/unbreakable accessories/SILVER GHAMELA 222.png';
import Uimg17 from '../../img/unbreakable accessories/SILVER GHAMELA 33.png';
import Uimg16 from '../../img/unbreakable accessories/SILVER GHAMELA 5.png';
import Uimg18 from '../../img/unbreakable accessories/SILVER GHAMELA 66.png';
import Uimg19 from '../../img/unbreakable accessories/SILVER GHAMELA 78.png';

import Uimg21 from '../../img/unbreakable accessories/CEMENT TAGRI 123.png';
import Uimg22 from '../../img/unbreakable accessories/CEMENT TAGRI 156.png';


//  Storage Organisers
import Simg3 from '../../img/storage organisers/222- red (2).png';
import Simg31 from '../../img/storage organisers/all colors (1).png';
import Simg13 from '../../img/storage organisers/chocolate brown (4).png';
import Simg14 from '../../img/storage organisers/Coffee brown (4).png';
import Simg36 from '../../img/storage organisers/Coffee brown 2.png';
import Simg37 from '../../img/storage organisers/Copy of BLACK (6).png';
import Simg9 from '../../img/storage organisers/Copy of H-222 (34).png';
import Simg6 from '../../img/storage organisers/Copy of H-222 (6).png';

import Simg43 from '../../img/storage organisers/Copy of HUMSAFAR BASKET (2).png';
import Simg34 from '../../img/storage organisers/Copy of LAUNDRY BASKET (13).png';
import Simg32 from '../../img/storage organisers/Copy of LAUNDRY BASKET (6).png';
import Simg39 from '../../img/storage organisers/Copy of light brown (1).png';
import Simg44 from '../../img/storage organisers/Cycle Basket_blue.png';
import Simg45 from '../../img/storage organisers/Cycle Basket_brown.png';
import Simg46 from '../../img/storage organisers/Cycle Basket_red.png';
import Simg19 from '../../img/storage organisers/dark brown (1).png';
import Simg20 from '../../img/storage organisers/dark brown (12).png';
import Simg21 from '../../img/storage organisers/dark brown (13).png';
import Simg22 from '../../img/storage organisers/grey (1).png';
import Simg23 from '../../img/storage organisers/grey (2).png';

import Simg24 from '../../img/storage organisers/grey (4).png';
import Simg10 from '../../img/storage organisers/hanger 333 brown (2).png';
import Simg11 from '../../img/storage organisers/hanger 333 orange (1).png';

import Simg12 from '../../img/storage organisers/hanger 333 pink (2).png';
import Simg15 from '../../img/storage organisers/HAZELNUT BROWN (8).png';
import Simg17 from '../../img/storage organisers/HUMSAFAR BASKET (1).png';
import Simg25 from '../../img/storage organisers/ivory (1).png';
import Simg26 from '../../img/storage organisers/ivory (2).png';
import Simg27 from '../../img/storage organisers/ivory (3).png';
import Simg40 from '../../img/storage organisers/laundry basket (5).png';
import Simg41 from '../../img/storage organisers/LAUNDRY BASKet (9).png';
import Simg42 from '../../img/storage organisers/Laundry Basket12.png';
import Simg35 from '../../img/storage organisers/LAUNDRY BASKET_black.png';
import Simg38 from '../../img/storage organisers/Light brown 2.png';
import Simg16 from '../../img/storage organisers/MAX STAND_pink (6).png';
import Simg28 from '../../img/storage organisers/white (1).png';
import Simg29 from '../../img/storage organisers/white (2).png';
import Simg30 from '../../img/storage organisers/white (4).png';

import Simg47 from '../../img/storage organisers/3pcs set.png';
import Simg48 from '../../img/storage organisers/Copy of KEEPER (10).png';
import Simg50 from '../../img/storage organisers/crop.png';
import Simg51 from '../../img/storage organisers/KEEPER (9).png';
// import Simg52 from '../../img/storage organisers/keeper (11) - Copy.JPG.'

import Simg53 from '../../img/storage organisers/KEEPER (1).png';
import Simg56 from '../../img/storage organisers/KEEPER (4).png';



import Simg58 from '../../img/storage organisers/hanger 111/111- brown (4).png';
import Simg59 from '../../img/storage organisers/hanger 111/111- green (4).png';
import Simg60 from '../../img/storage organisers/hanger 111/111- orange (4).png';
import Simg61 from '../../img/storage organisers/hanger 111/111- orange (6).png';
import Simg62 from '../../img/storage organisers/hanger 111/111- pink (3).png';
import Simg63 from '../../img/storage organisers/hanger 111/111- pink (4).png';
import Simg64 from '../../img/storage organisers/hanger 111/111- red (2).png';
import Simg65 from '../../img/storage organisers/hanger 111/111- red (4).png';
import Simg67 from '../../img/storage organisers/hanger 111/Copy of H-111 (12).png';
import Simg68 from '../../img/storage organisers/hanger 111/Copy of H-111 (19).png';
import Simg69 from '../../img/storage organisers/hanger 111/Copy of H-111 (23).png';
import Simg70 from '../../img/storage organisers/hanger 111/Copy of H-111 (24).png';
import Simg71 from '../../img/storage organisers/hanger 111/Copy of H-111 (30).png';
import Simg66 from '../../img/storage organisers/hanger 111/Copy of H-111 (4).png';
import Simg72 from '../../img/storage organisers/hanger 111/Copy of H-111 (41).png';
import Simg73 from '../../img/storage organisers/hanger 111/H-111 (13)(1).png';
import Simg74 from '../../img/storage organisers/hanger 111/H-111 (46)(1).png';


import Simg75 from '../../img/storage organisers/hanger 222/222 - orange (5).png';
import Simg76 from '../../img/storage organisers/hanger 222/222- brown (1).png';
import Simg77 from '../../img/storage organisers/hanger 222/222- multi-color (2).png';
import Simg78 from '../../img/storage organisers/hanger 222/222- red (2).png';
import Simg79 from '../../img/storage organisers/hanger 222/222- red (4).png';
import Simg85 from '../../img/storage organisers/hanger 222/Copy of H-222 (18).png';
import Simg80 from '../../img/storage organisers/hanger 222/Copy of H-222 (4).png';
import Simg83 from '../../img/storage organisers/hanger 222/Copy of H-222 (6)_green.png';
import Simg84 from '../../img/storage organisers/hanger 222/Copy of H-222 (6)_green_6 Sets.png';
import Simg86 from '../../img/storage organisers/hanger 222/H-222 (29)(1).png';
import Simg87 from '../../img/storage organisers/hanger 222/H-222 (29)_6 Sets.png';


import Simg88 from '../../img/storage organisers/hanger 333/hanger 333 all (6).png';
import Simg89 from '../../img/storage organisers/hanger 333/hanger 333 brown (2).png';
import Simg90 from '../../img/storage organisers/hanger 333/hanger 333 orange (1).png';
import Simg91 from '../../img/storage organisers/hanger 333/hanger 333 pink (2).png';

import Simg92 from '../../img/storage organisers/IB0_9718.png';
import Simg93 from '../../img/storage organisers/IB0_9739.png';
import Simg94 from '../../img/storage organisers/IB0_9757.png';

import Simg96 from '../../img/storage organisers/Humsafar Basket.png';
import Simg95 from '../../img/storage organisers/HUMSAFAR_black.png';



// Cleaning Utilities
import Cimg1 from '../../img/cleaning utilities/Copy of JALI DUSTBIN (1).png';
import Cimg2 from '../../img/cleaning utilities/Copy of PLAIN DUSTBIN (2).png';
import Cimg3 from '../../img/cleaning utilities/Copy of PLAIN DUSTBIN (5).png';
import Cimg4 from '../../img/cleaning utilities/Copy of PLAIN DUSTBIN (6).png';
import Cimg5 from '../../img/cleaning utilities/DC DUSTBIN (2).png';
import Cimg33 from '../../img/cleaning utilities/IB0_9851.png';
import Cimg6 from '../../img/cleaning utilities/image (10).png';
import Cimg7 from '../../img/cleaning utilities/image (12).png';
import Cimg8 from '../../img/cleaning utilities/image (13).png';
import Cimg9 from '../../img/cleaning utilities/MINI SWING BIN (1).png';
import Cimg10 from '../../img/cleaning utilities/MINI SWING BIN (3).png';
import Cimg11 from '../../img/cleaning utilities/MINI SWING BIN (4).png';
import Cimg19 from '../../img/cleaning utilities/pedal bin (1).png';
import Cimg20 from '../../img/cleaning utilities/pedal bin (3) (1).png';
import Cimg21 from '../../img/cleaning utilities/PEDAL BIN (3).png';
import Cimg22 from '../../img/cleaning utilities/PEDAL BIN (5).png';
import Cimg29 from '../../img/cleaning utilities/ROUND DRUM (1).png';
import Cimg30 from '../../img/cleaning utilities/ROUND DRUM (2).png';
import Cimg31 from '../../img/cleaning utilities/ROUND DRUM (5).png';
import Cimg32 from '../../img/cleaning utilities/ROUND DRUM (6).png';
import Cimg15 from '../../img/cleaning utilities/ROUND SWING BIN (11).png';
import Cimg12 from '../../img/cleaning utilities/ROUND SWING BIN (3).png';
import Cimg13 from '../../img/cleaning utilities/ROUND SWING BIN (6)_BLUE.png';
import Cimg14 from '../../img/cleaning utilities/ROUND SWING BIN (8).png';
import Cimg16 from '../../img/cleaning utilities/SQ SWING BINS (2).png';
import Cimg17 from '../../img/cleaning utilities/SQ SWING BINS (3).png';
import Cimg18 from '../../img/cleaning utilities/SQ SWING BINS (4).png';
import Cimg23 from '../../img/cleaning utilities/SQUARE DOME (6).png';
import Cimg24 from '../../img/cleaning utilities/SQUARE DOME (7).png';
import Cimg25 from '../../img/cleaning utilities/SQUARE DOME (8).png';

import Cimg26 from '../../img/cleaning utilities/SQUARE DOME_blue.png';
import Cimg27 from '../../img/cleaning utilities/SQUARE DOME_green.png';

import Cimg28 from '../../img/cleaning utilities/SQUARE SWING BIN.png';


import Cimg34 from '../../img/cleaning utilities/DUSTPAN.png';
import Cimg35 from '../../img/cleaning utilities/DUSTPAN3.png';
import Cimg36 from '../../img/cleaning utilities/DUSTPAN6.png';
import Cimg37 from '../../img/cleaning utilities/DUSTPAN7.png';
import Cimg38 from '../../img/cleaning utilities/DUSTPANS1.png';

// Kitchen Products
import Kimg1 from '../../img/kitchen/BARTANJALI (1).png';
import Kimg11 from '../../img/kitchen/Copy of food-saver blue (5) (1).png';
import Kimg18 from '../../img/kitchen/Copy of Glass Stand Black (1).png';
import Kimg29 from '../../img/kitchen/Copy of KITCHEN BASKET  (1).png';
import Kimg30 from '../../img/kitchen/DC BASIN (8).png';
import Kimg36 from '../../img/kitchen/dc colander (1).png';
import Kimg72 from '../../img/kitchen/grey (10)_white (1).png';
import Kimg43 from '../../img/kitchen/JALDHARA JUG (1).png';
import Kimg48 from '../../img/kitchen/KC SET PRINTED (5).png';
import Kimg50 from '../../img/kitchen/masala box all colors (4).png';
import Kimg73 from '../../img/kitchen/TRAY (1).png';
import Kimg52 from '../../img/kitchen/vatti orange (10).png';
// import Kimg82 from '../../img/kitchen/KITCHEN BASKET (2).JPG'









const categories = [
  'Bathroom Accessories',
  'Kitchen Products',
  'Gardening',
  'Pata and Stools',
  'Storage Organisers',
  'Cleaning Utilities',
  'Unbreakable Accessories',
  'Moulded Furniture Range',
];

const products = [

// Kitchen Products com
{id:101,name: 'BARTANJALI ', category: 'Kitchen Products', img:Kimg1,productName:'KITCHEN ALL PRODUCT'},
{id:111, name: 'food-saver ', category: 'Kitchen Products', img:Kimg11,productName:'KITCHEN ALL PRODUCT' },
{id:118, name: 'Glass Stand ', category: 'Kitchen Products', img:Kimg18,productName:'KITCHEN ALL PRODUCT' },
{id:127, name: 'KITCHEN BASKET', category: 'Kitchen Products', img:Kimg29,productName:'KITCHEN ALL PRODUCT' },
{id:128, name: 'DC BASIN', category: 'Kitchen Products', img:Kimg30,productName:'KITCHEN ALL PRODUCT' },
{id:134, name: 'dc colander', category: 'Kitchen Products', img:Kimg36,productName:'KITCHEN ALL PRODUCT' },
{id:141, name: 'JALDHARA JUG', category: 'Kitchen Products', img:Kimg43,productName:'KITCHEN ALL PRODUCT' },
{id:146, name: 'KC SET PRINTED', category: 'Kitchen Products', img:Kimg48,productName:'KITCHEN ALL PRODUCT' },
{id:148, name: 'Cane masala box all colors', category: 'Kitchen Products', img:Kimg50,productName:'KITCHEN ALL PRODUCT' },
{id:170, name: 'Cane masala box', category: 'Kitchen Products', img:Kimg72,productName:'KITCHEN ALL PRODUCT' },
{id:171, name: 'kitchen TRAY', category: 'Kitchen Products', img:Kimg73,productName:'KITCHEN ALL PRODUCT' },
// {id:178, name: 'KITCHEN BASKET ', category: 'Kitchen Products', img:Kimg80,productName:'KITCHEN ALL PRODUCT' },
// {id:102, name: 'BARTANJALI ', category: 'Kitchen Products', img:Kimg2,productName:'KITCHEN ALL PRODUCT' },
// {id:112, name: 'food-saver ', category: 'Kitchen Products', img:Kimg12,productName:'KITCHEN ALL PRODUCT' },
// {id:119, name: 'Glass Stand ', category: 'Kitchen Products', img:Kimg19,productName:'KITCHEN ALL PRODUCT' },
// {id:129, name: 'DC BASIN ', category: 'Kitchen Products', img:Kimg31,productName:'KITCHEN ALL PRODUCT' },
// {id:135, name: 'dc colander ', category: 'Kitchen Products', img:Kimg37,productName:'KITCHEN ALL PRODUCT' },
// {id:142, name: 'JALDHARA JUG ', category: 'Kitchen Products', img:Kimg44,productName:'KITCHEN ALL PRODUCT' },
// {id:149, name: ' Cane masala box all colors', category: 'Kitchen Products', img:Kimg51,productName:'KITCHEN ALL PRODUCT' },
// {id:172, name: 'kitchen TRAY  ', category: 'Kitchen Products', img:Kimg74,productName:'KITCHEN ALL PRODUCT' },
// {id:103, name: 'BARTANJALI ', category: 'Kitchen Products', img:Kimg3,productName:'KITCHEN ALL PRODUCT' },

// {id:120, name: 'Glass Stand ', category: 'Kitchen Products', img:Kimg20,productName:'KITCHEN ALL PRODUCT' },
// {id:130, name: 'DC BASIN ', category: 'Kitchen Products', img:Kimg32,productName:'KITCHEN ALL PRODUCT' },
// {id:136, name: 'dc colander ', category: 'Kitchen Products', img:Kimg38,productName:'KITCHEN ALL PRODUCT' },

{id:150, name: 'Cane masala Box', category: 'Kitchen Products', img:Kimg52,productName:'KITCHEN ALL PRODUCT' },
// {id:173, name: 'kitchen TRAY ', category: 'Kitchen Products', img:Kimg75,productName:'KITCHEN ALL PRODUCT' },
// {id:104, name: 'BARTANJALI ', category: 'Kitchen Products', img:Kimg4,productName:'KITCHEN ALL PRODUCT' },
// {id:114, name: 'food-saver ', category: 'Kitchen Products', img:Kimg14,productName:'KITCHEN ALL PRODUCT' },
// {id:121, name: 'Glass Stand ', category: 'Kitchen Products', img:Kimg21,productName:'KITCHEN ALL PRODUCT' },
// {id:131, name: 'DC BASIN ', category: 'Kitchen Products', img:Kimg33,productName:'KITCHEN ALL PRODUCT' },
// {id:137, name: 'dc colander ', category: 'Kitchen Products', img:Kimg39,productName:'KITCHEN ALL PRODUCT' },
// {id:144, name: 'JALDHARA JUG ', category: 'Kitchen Products', img:Kimg46,productName:'KITCHEN ALL PRODUCT' },
// {id:151, name: 'Cane masala Box  ', category: 'Kitchen Products', img:Kimg53,productName:'KITCHEN ALL PRODUCT' },
// {id:174, name: 'kitchen TRAY ', category: 'Kitchen Products', img:Kimg76,productName:'KITCHEN ALL PRODUCT' },
// {id:105, name: 'BARTANJALI ', category: 'Kitchen Products', img:Kimg5,productName:'KITCHEN ALL PRODUCT' },
// {id:115, name: 'food-saver', category: 'Kitchen Products', img:Kimg15,productName:'KITCHEN ALL PRODUCT' },
// {id:122, name: 'Glass Stand ', category: 'Kitchen Products', img:Kimg22,productName:'KITCHEN ALL PRODUCT' },
// {id:132, name: 'DC BASIN ', category: 'Kitchen Products', img:Kimg34,productName:'KITCHEN ALL PRODUCT' },
// {id:138, name: 'dc colander ', category: 'Kitchen Products', img:Kimg40,productName:'KITCHEN ALL PRODUCT' },

// {id:152, name: 'Cane masala Box ', category: 'Kitchen Products', img:Kimg54,productName:'KITCHEN ALL PRODUCT' },

// {id:106, name: 'BARTANJALI ', category: 'Kitchen Products', img:Kimg6,productName:'KITCHEN ALL PRODUCT' },
// {id:116, name: 'food-saver ', category: 'Kitchen Products', img:Kimg16,productName:'KITCHEN ALL PRODUCT' },

// {id:133, name: 'DC BASIN ', category: 'Kitchen Products', img:Kimg35,productName:'KITCHEN ALL PRODUCT' },
// {id:139, name: 'dc colander ', category: 'Kitchen Products', img:Kimg41,productName:'KITCHEN ALL PRODUCT' },
// {id:146, name: 'KC SET PRINTED', category: 'Kitchen Products', img:Kimg48,productName:'KITCHEN ALL PRODUCT' },
// {id:153, name: 'Cane masala Box ', category: 'Kitchen Products', img:Kimg55,productName:'KITCHEN ALL PRODUCT' },

// {id:107, name: 'BARTANJALI  ', category: 'Kitchen Products', img:Kimg7,productName:'KITCHEN ALL PRODUCT' },
// {id:117, name: 'food-saver ', category: 'Kitchen Products', img:Kimg17,productName:'KITCHEN ALL PRODUCT' },
// {id:124, name: 'Glass Stand ', category: 'Kitchen Products', img:Kimg24,productName:'KITCHEN ALL PRODUCT' },
// {id:140, name: 'dc colander ', category: 'Kitchen Products', img:Kimg42,productName:'KITCHEN ALL PRODUCT' },
// {id:154, name: 'Cane masala Box ', category: 'Kitchen Products', img:Kimg56,productName:'KITCHEN ALL PRODUCT' },
// {id:177, name: 'masala box all colors', category: 'Kitchen Products', img:Kimg79,productName:'KITCHEN ALL PRODUCT' },

// {id:125, name: 'Glass Stand ', category: 'Kitchen Products', img:Kimg25,productName:'KITCHEN ALL PRODUCT' },


// {id:126, name: 'Glass Stand ', category: 'Kitchen Products', img:Kimg26,productName:'KITCHEN ALL PRODUCT' },
// {id:156, name: 'Cane masala Box', category: 'Kitchen Products', img:Kimg58,productName:'KITCHEN ALL PRODUCT' },
// {id:157, name: 'Cane masala Box', category: 'Kitchen Products', img:Kimg59,productName:'KITCHEN ALL PRODUCT' },
// {id:158, name: 'Cane masala Box', category: 'Kitchen Products', img:Kimg60,productName:'KITCHEN ALL PRODUCT' },
// {id:159, name: 'Cane masala Box', category: 'Kitchen Products', img:Kimg61,productName:'KITCHEN ALL PRODUCT' },
// {id:160, name: 'Cane masala Box', category: 'Kitchen Products', img:Kimg62,productName:'KITCHEN ALL PRODUCT' },
// {id:161, name: 'Cane masala Box ', category: 'Kitchen Products', img:Kimg63,productName:'KITCHEN ALL PRODUCT' },
// {id:162, name: 'Cane masala Box ', category: 'Kitchen Products', img:Kimg64,productName:'KITCHEN ALL PRODUCT' },
// {id:163, name: 'Cane masala Box ', category: 'Kitchen Products', img:Kimg65,productName:'KITCHEN ALL PRODUCT' },
// {id:164, name: 'Cane masala Box ', category: 'Kitchen Products', img:Kimg66,productName:'KITCHEN ALL PRODUCT' },
// {id:165, name: 'Cane masala Box', category: 'Kitchen Products', img:Kimg67,productName:'KITCHEN ALL PRODUCT' },
// {id:166, name: 'Cane masala Box ', category: 'Kitchen Products', img:Kimg68,productName:'KITCHEN ALL PRODUCT' },
// {id:167, name: 'Cane masala BOX ', category: 'Kitchen Products', img:Kimg69,productName:'KITCHEN ALL PRODUCT' },
// {id:168, name: 'Cane masala Box ', category: 'Kitchen Products', img:Kimg70 ,productName:'KITCHEN ALL PRODUCT'},
// {id:169, name: 'Cane masala Box', category: 'Kitchen Products', img:Kimg71,productName:'KITCHEN ALL PRODUCT' },
// {id:179, name: 'KITCHEN BASKET ', category: 'Kitchen Products', img:Kimg81,productName:'KITCHEN ALL PRODUCT' },
// {id:180, name: 'KITCHEN BASKET ', category: 'Kitchen Products', img:Kimg83,productName:'KITCHEN ALL PRODUCT' },
// {id:181, name: 'KITCHEN BASKET ', category: 'Kitchen Products', img:Kimg84,productName:'KITCHEN ALL PRODUCT' },
// {id:182, name: 'KITCHEN BASKET ', category: 'Kitchen Products', img:Kimg85,productName:'KITCHEN ALL PRODUCT' },
// {id:183, name: 'KITCHEN BASKET ', category: 'Kitchen Products', img:Kimg86,productName:'KITCHEN ALL PRODUCT' },
// {id:184, name: 'KITCHEN BASKET ', category: 'Kitchen Products', img:Kimg87,productName:'KITCHEN ALL PRODUCT' },




  // Bathroom Accessories com

  {id:201, name: 'DC BUCKET', category: 'Bathroom Accessories', img: img1,productName: 'bucket'  },
  {id:202, name: 'DC BUCKET', category: 'Bathroom Accessories', img: img4,productName: 'bucket'  },
  {id:203, name: 'LB BUCKET', category: 'Bathroom Accessories', img: img3 ,productName: 'bucket' },
  {id:204, name: 'LB  BUCKET', category: 'Bathroom Accessories', img: img2 ,productName: 'bucket' },
  {id:205, name: 'GOLD BUCKET1 ', category: 'Bathroom Accessories', img: img5 ,productName: 'bucket' },
  {id:206, name: 'SQUARE BUCKET', category: 'Bathroom Accessories', img: img6,productName: 'bucket'  },
  
  {id:208, name: 'SQUARE BUCKET', category: 'Bathroom Accessories', img: img8,productName: 'bucket'  },
  {id:209, name: 'LB WITH LID BUCKET', category: 'Bathroom Accessories', img: img9,productName: 'bucket'  },
  {id:210, name: 'LB WITH LID BUCKET', category: 'Bathroom Accessories', img: img10,productName: 'bucket'  },
  {id:211, name: 'CLOSE HANDLE MUG   ', category: 'Bathroom Accessories', img: img11,productName: 'mug'  },
  {id:212, name: 'CLOSE HANDLE MUGS ', category: 'Bathroom Accessories', img: img12,productName: 'mug' },
  {id:213, name: 'DC MUGS  ', category: 'Bathroom Accessories', img: img13,productName: 'mug' },
  {id:214, name: 'DC MUGS ', category: 'Bathroom Accessories', img: img14,productName: 'mug' },
  {id:215, name: 'DUPLEX MUGS  ', category: 'Bathroom Accessories', img: img15,productName: 'mug' },
  
  {id:217, name: 'GOLD BUCKET1 ', category: 'Bathroom Accessories', img: img17,productName: 'bucket'  },
  {id:218, name: 'GOLD BUCKET1 ', category: 'Bathroom Accessories', img: img18,productName: 'bucket'  },
  {id:219, name: 'GOLD BUCKET1  ', category: 'Bathroom Accessories', img: img19,productName: 'bucket'  },
  {id:220, name: 'LB BUCKET ', category: 'Bathroom Accessories', img: img20,productName: 'bucket'  },
  {id:221, name: 'SQUARE BUCKET  ', category: 'Bathroom Accessories', img: img21,productName: 'bucket'  },
  {id:220, name: 'SQUARE BUCKET MIX  ', category: 'Bathroom Accessories', img: img22,productName: 'bucket'  },
  {id:221, name: 'GOLD BUCKET1', category: 'Bathroom Accessories', img: img23,productName: 'bucket'  },
  {id:222, name: 'LB BUCKET MIX ', category: 'Bathroom Accessories', img: img24,productName: 'bucket'  },
  {id:223, name: 'SQUARE BUCKET', category: 'Bathroom Accessories', img: img25,productName: 'bucket'  },
  {id:224, name: 'PEARL BLUE', category: 'Bathroom Accessories', img: img26,productName:'Corner rack' },
  {id:225, name: 'PEARL LIGHT BLACK', category: 'Bathroom Accessories', img: img27,productName:'Corner rack' },
  {id:226, name: 'PEARL WHITE', category: 'Bathroom Accessories', img: img28,productName:'Corner rack' },
  {id:227, name: 'PEARL BLACK', category: 'Bathroom Accessories', img: img29,productName:'Corner rack' },
  {id:228, name: 'PEARL PINK', category: 'Bathroom Accessories', img: img30,productName:'Corner rack' },
  {id:229, name: 'SUPER TUB ', category: 'Bathroom Accessories', img: img31,productName:'tub' },
  {id:230, name: 'SUPER TUB ', category: 'Bathroom Accessories', img: img32,productName:'tub'  },
  {id:231, name: 'SUPER TUB ', category: 'Bathroom Accessories', img: img33,productName:'tub'  },

  {id:232, name: 'Baby Bath tub ', category: 'Bathroom Accessories', img: img34,productName:'Baby Bath tub'  },
  {id:233, name: 'Baby Bath tub ', category: 'Bathroom Accessories', img: img35,productName:'Baby Bath tub'  },
  {id:234, name: 'Baby Bath tub ', category: 'Bathroom Accessories', img: img36,productName:'Baby Bath tub'  },
  {id:235, name: 'Baby Bath tub', category: 'Bathroom Accessories', img: img37,productName:'Baby Bath tub'  },
  


  {id:237, name: 'blue bathstool', category: 'Bathroom Accessories', img: img39,productName:'Printed series'  },
  {id:238, name: 'blue bucket', category: 'Bathroom Accessories', img: img40,productName:'Printed series'  },
  {id:239, name: 'BLUE PEDALBIN', category: 'Bathroom Accessories', img: img41,productName:'Printed series'  },
  {id:240, name: '6 PCS SET', category: 'Bathroom Accessories', img: img42,productName:'Printed series'  },
  {id:241, name: 'Blue set  ', category: 'Bathroom Accessories', img: img43,productName:'Printed series'  },
  {id:242, name: 'pink bathstool ', category: 'Bathroom Accessories', img: img44,productName:'Printed series'  },
  {id:243, name: 'pink bucket', category: 'Bathroom Accessories', img: img45,productName:'Printed series'  },
  {id:244, name: 'pink pedalbin ', category: 'Bathroom Accessories', img: img46,productName:'Printed series'  },
  {id:245, name: 'Pink set 6pcs', category: 'Bathroom Accessories', img: img47,productName:'Printed series'  },
  {id:246, name: 'Pink set ', category: 'Bathroom Accessories', img: img48,productName:'Printed series'  },
  {id:247, name: 'printed mug ', category: 'Bathroom Accessories', img: img49,productName:'Printed series'  },
  {id:248, name: 'printed  tubs', category: 'Bathroom Accessories', img: img50,productName:'Printed series'  },
  {id:249, name: 'Soapcase', category: 'Bathroom Accessories', img: img51,productName:'Printed series'  },
  {id:250, name: 'yellow bathstool', category: 'Bathroom Accessories', img: img52,productName:'Printed series'  },
  {id:251, name: 'yellow bucket ', category: 'Bathroom Accessories', img: img53,productName:'Printed series'  },

  {id:252, name: 'yellow pedalbin', category: 'Bathroom Accessories', img: img54,productName:'Printed series'  },
  {id:253, name: 'Yellow set 6pcs', category: 'Bathroom Accessories', img: img55,productName:'Printed series'  },

  {id:254, name: 'Yellow set', category: 'Bathroom Accessories', img: img56,productName:'Printed series'  },








// new  com

{id: 301, name: 'HOOK-POT PLANTER', category: 'Gardening', img: Gimg1, productName: 'GARDENING ALL PRODUCT'},
{id: 308, name: 'DECOR PLANTER', category: 'Gardening', img: Gimg8, productName: 'GARDENING ALL PRODUCT'},
{id: 316, name: 'OCTA PLANTER', category: 'Gardening', img: Gimg16, productName: 'GARDENING ALL PRODUCT'},
{id: 324, name: 'VERTICAL WALL HANGING', category: 'Gardening', img: Gimg24, productName: 'GARDENING ALL PRODUCT'},
  // {id: 305, name: 'HOOK-POT PLANTER MIX', category: 'Gardening', img: Gimg5, productName: 'GARDENING ALL PRODUCT'},
  // {id: 311, name: 'DECOR PLANTER', category: 'Gardening', img: Gimg11, productName: 'GARDENING ALL PRODUCT'},
  // {id: 317, name: 'OCTA PLANTER', category: 'Gardening', img: Gimg17, productName: 'GARDENING ALL PRODUCT'},
  // {id: 302, name: 'HOOK-POT PLANTER', category: 'Gardening', img: Gimg2, productName: 'GARDENING ALL PRODUCT'},
  // {id: 309, name: 'DECOR PLANTER', category: 'Gardening', img: Gimg9, productName: 'GARDENING ALL PRODUCT'},
  // {id: 318, name: 'OCTA PLANTER', category: 'Gardening', img: Gimg18, productName: 'GARDENING ALL PRODUCT'},
  // {id: 312, name: 'DECOR PLANTER', category: 'Gardening', img: Gimg12, productName: 'GARDENING ALL PRODUCT'},
  // {id: 304, name: 'HOOK-POT PLANTER', category: 'Gardening', img: Gimg4, productName: 'GARDENING ALL PRODUCT'},
  // {id: 321, name: 'OCTA PLANTER', category: 'Gardening', img: Gimg21, productName: 'GARDENING ALL PRODUCT'},
  {id: 306, name: 'HOOK-POT PLANTER MIX', category: 'Gardening', img: Gimg6, productName: 'GARDENING ALL PRODUCT'},
  // {id: 315, name: 'DECOR PLANTER', category: 'Gardening', img: Gimg15, productName: 'GARDENING ALL PRODUCT'},
  // {id: 320, name: 'OCTA PLANTER', category: 'Gardening', img: Gimg20, productName: 'GARDENING ALL PRODUCT'},
  // {id: 307, name: 'HOOK-POT PLANTER', category: 'Gardening', img: Gimg7, productName: 'GARDENING ALL PRODUCT'},
  // {id: 322, name: 'OCTA PLANTER', category: 'Gardening', img: Gimg22, productName: 'GARDENING ALL PRODUCT'},
  // {id: 310, name: 'DECOR PLANTER', category: 'Gardening', img: Gimg10, productName: 'GARDENING ALL PRODUCT'},
  // {id: 313, name: 'DECOR PLANTER', category: 'Gardening', img: Gimg13, productName: 'GARDENING ALL PRODUCT'},
  // {id: 319, name: 'OCTA PLANTER', category: 'Gardening', img: Gimg19, productName: 'GARDENING ALL PRODUCT'},
  // {id: 314, name: 'DECOR PLANTER', category: 'Gardening', img: Gimg14, productName: 'GARDENING ALL PRODUCT'},
  // {id: 303, name: 'HOOK-POT PLANTER', category: 'Gardening', img: Gimg3, productName: 'GARDENING ALL PRODUCT'},
  // {id: 323, name: 'OCTA PLANTER', category: 'Gardening', img: Gimg23, productName: 'GARDENING ALL PRODUCT'},
  // {id: 325, name: 'VERTICAL WALL HANGING', category: 'Gardening', img: Gimg25, productName: 'GARDENING ALL PRODUCT'},

// new Pata and Stools

// { name: 'Vertical Planter set', category: 'Pata and Stools', img: Pimg1 },


// new Unbreakable Accessories


{ id: 501, name: 'GOLD GHAMELA', category: 'Unbreakable Accessories', img: Uimg1, productName: 'GOLD GHAMELA' },
{ id: 502, name: 'GOLD GHAMELA', category: 'Unbreakable Accessories', img: Uimg2, productName: 'GOLD GHAMELA' },
{ id: 503, name: 'GOLD GHAMELA', category: 'Unbreakable Accessories', img: Uimg3, productName: 'GOLD GHAMELA' },
{ id: 504, name: 'GOLD GHAMELA', category: 'Unbreakable Accessories', img: Uimg4, productName: 'GOLD GHAMELA' },
{ id: 505, name: 'GOLD GHAMELA', category: 'Unbreakable Accessories', img: Uimg5, productName: 'GOLD GHAMELA' },
{ id: 506, name: 'CEMENT TAGARI', category: 'Unbreakable Accessories', img: Uimg6, productName: 'CEMENT TAGARI' },
{ id: 507, name: 'CEMENT TAGARI', category: 'Unbreakable Accessories', img: Uimg21, productName: 'CEMENT TAGARI' },
{ id: 508, name: 'CEMENT TAGARI', category: 'Unbreakable Accessories', img: Uimg22, productName: 'CEMENT TAGARI' },
{ id: 509, name: 'CONSTRO TAGARI', category: 'Unbreakable Accessories', img: Uimg7, productName: 'CONSTRO TAGARI' },
{ id: 510, name: 'CONSTRO TAGARI', category: 'Unbreakable Accessories', img: Uimg8, productName: 'CONSTRO TAGARI' },
{ id: 511, name: 'CONSTRO TAGARI', category: 'Unbreakable Accessories', img: Uimg9, productName: 'CONSTRO TAGARI' },
{ id: 512, name: 'GOLD BUCKET', category: 'Unbreakable Accessories', img: Uimg10, productName: 'GOLD BUCKET' },
{ id: 513, name: 'GOLD BUCKET', category: 'Unbreakable Accessories', img: Uimg12, productName: 'GOLD BUCKET' },
{ id: 514, name: 'GOLD BUCKET', category: 'Unbreakable Accessories', img: Uimg13, productName: 'GOLD BUCKET' },
{ id: 515, name: 'GOLD BUCKET', category: 'Unbreakable Accessories', img: Uimg14, productName: 'GOLD BUCKET' },
{ id: 516, name: 'SILVER GHAMELA', category: 'Unbreakable Accessories', img: Uimg15, productName: 'SILVER GHAMELA' },
{ id: 517, name: 'SILVER GHAMELA', category: 'Unbreakable Accessories', img: Uimg16, productName: 'SILVER GHAMELA' },
{ id: 518, name: 'SILVER GHAMELA', category: 'Unbreakable Accessories', img: Uimg17, productName: 'SILVER GHAMELA' },
{ id: 519, name: 'SILVER GHAMELA', category: 'Unbreakable Accessories', img: Uimg18, productName: 'SILVER GHAMELA' },
{ id: 520, name: 'SILVER GHAMELA', category: 'Unbreakable Accessories', img: Uimg19, productName: 'SILVER GHAMELA' },
{ id: 521, name: 'SILVER GHAMELA', category: 'Unbreakable Accessories', img: Uimg20, productName: 'SILVER GHAMELA' },

// Pata and Stools com
{ id: 401, name: 'Bath Stool', category: 'Pata and Stools', img: Pimg1, productName: 'PATA & STOOL ALL PRODUCT', description: 'Durable and comfortable bath stool.' },
{ id: 405, name: 'GAJANI PATA', category: 'Pata and Stools', img: Pimg5, productName: 'PATA & STOOL ALL PRODUCT', description: 'Traditional Gajani Pata for multipurpose use.' },
{ id: 402, name: 'Bath Stool', category: 'Pata and Stools', img: Pimg2, productName: 'PATA & STOOL ALL PRODUCT', description: 'Stylish bath stool for daily use.' },
{ id: 406, name: 'GAJANI PATA', category: 'Pata and Stools', img: Pimg6, productName: 'PATA & STOOL ALL PRODUCT', description: 'Durable Gajani Pata for various applications.' },
{ id: 403, name: 'Bath Stool', category: 'Pata and Stools', img: Pimg3, productName: 'PATA & STOOL ALL PRODUCT', description: 'Ergonomic design for a comfortable bath experience.' },
{ id: 407, name: 'GAJANI PATA', category: 'Pata and Stools', img: Pimg7, productName: 'PATA & STOOL ALL PRODUCT', description: 'Quality Gajani Pata for everyday use.' },
{ id: 404, name: 'Bath Stool', category: 'Pata and Stools', img: Pimg4, productName: 'PATA & STOOL ALL PRODUCT', description: 'Compact and sturdy bath stool.' },
{ id: 408, name: 'GAJANI PATA', category: 'Pata and Stools', img: Pimg8, productName: 'PATA & STOOL ALL PRODUCT', description: 'Reliable and strong Gajani Pata.' },
{ id: 409, name: 'KRISH PATA', category: 'Pata and Stools', img: Pimg9, productName: 'PATA & STOOL ALL PRODUCT', description: 'Elegant Krish Pata for various uses.' },
{ id: 413, name: 'JUMBO PANDA STOOL', category: 'Pata and Stools', img: Pimg13, productName: 'PATA & STOOL ALL PRODUCT', description: 'Large and sturdy Jumbo Panda stool.' },
{ id: 410, name: 'KRISH PATA', category: 'Pata and Stools', img: Pimg10, productName: 'PATA & STOOL ALL PRODUCT', description: 'High-quality Krish Pata for home and office.' },
{ id: 414, name: 'JUMBO PANDA STOOL', category: 'Pata and Stools', img: Pimg14, productName: 'PATA & STOOL ALL PRODUCT', description: 'Comfortable Jumbo Panda stool for all ages.' },
{ id: 411, name: 'GAJANI PATA', category: 'Pata and Stools', img: Pimg11, productName: 'PATA & STOOL ALL PRODUCT', description: 'Sturdy Gajani Pata for all purposes.' },
{ id: 415, name: 'JUMBO PANDA STOOL', category: 'Pata and Stools', img: Pimg15, productName: 'PATA & STOOL ALL PRODUCT', description: 'Durable and stylish Jumbo Panda stool.' },
{ id: 412, name: 'GAJANI PATA', category: 'Pata and Stools', img: Pimg12, productName: 'PATA & STOOL ALL PRODUCT', description: 'Versatile Gajani Pata for daily use.' },
{ id: 416, name: 'JUMBO PANDA STOOL', category: 'Pata and Stools', img: Pimg16, productName: 'PATA & STOOL ALL PRODUCT', description: 'High-quality Jumbo Panda stool for various uses.' },
{ id: 417, name: 'JUMBO PANDA STOOL', category: 'Pata and Stools', img: Pimg17, productName: 'PATA & STOOL ALL PRODUCT', description: 'Strong and reliable Jumbo Panda stool.' },
{ id: 418, name: 'KRISH PATA', category: 'Pata and Stools', img: Pimg18, productName: 'PATA & STOOL ALL PRODUCT', description: 'Elegant Krish Pata for multiple uses.' },
{ id: 421, name: 'RIO PATA', category: 'Pata and Stools', img: Pimg21, productName: 'PATA & STOOL ALL PRODUCT', description: 'Modern Rio Pata for various applications.' },
{ id: 419, name: 'KRISH PATA', category: 'Pata and Stools', img: Pimg19, productName: 'PATA & STOOL ALL PRODUCT', description: 'Quality Krish Pata for home and office.' },
{ id: 422, name: 'RIO PATA', category: 'Pata and Stools', img: Pimg22, productName: 'PATA & STOOL ALL PRODUCT', description: 'Stylish and durable Rio Pata.' },
{ id: 420, name: 'KRISH PATA', category: 'Pata and Stools', img: Pimg20, productName: 'PATA & STOOL ALL PRODUCT', description: 'Durable and versatile Krish Pata.' },
{ id: 423, name: 'RIO PATA', category: 'Pata and Stools', img: Pimg23, productName: 'PATA & STOOL ALL PRODUCT', description: 'High-quality Rio Pata for everyday use.' },
{ id: 424, name: 'RIO PATA', category: 'Pata and Stools', img: Pimg24, productName: 'PATA & STOOL ALL PRODUCT', description: 'Reliable Rio Pata for multiple uses.' },
{ id: 425, name: 'RIO PATA', category: 'Pata and Stools', img: Pimg25, productName: 'PATA & STOOL ALL PRODUCT', description: 'Durable and stylish Rio Pata.' },
{ id: 426, name: 'SHAKTIMAN PATA', category: 'Pata and Stools', img: Pimg26, productName: 'PATA & STOOL ALL PRODUCT', description: 'Strong Shaktiman Pata for various uses.' },
{ id: 427, name: 'SHAKTIMAN PATA', category: 'Pata and Stools', img: Pimg27, productName: 'PATA & STOOL ALL PRODUCT', description: 'Durable and reliable Shaktiman Pata.' },
{ id: 428, name: 'SHAKTIMAN PATA', category: 'Pata and Stools', img: Pimg28, productName: 'PATA & STOOL ALL PRODUCT', description: 'High-quality Shaktiman Pata for all purposes.' },
{ id: 429, name: 'SHAKTIMAN PATA', category: 'Pata and Stools', img: Pimg29, productName: 'PATA & STOOL ALL PRODUCT', description: 'Versatile Shaktiman Pata for daily use.' },
{ id: 430, name: 'SHAKTIMAN PATA', category: 'Pata and Stools', img: Pimg30, productName: 'PATA & STOOL ALL PRODUCT', description: 'Durable and modern Shaktiman Pata.' },
{ id: 431, name: 'KRISH PATA', category: 'Pata and Stools', img: Pimg31, productName: 'PATA & STOOL ALL PRODUCT', description: 'Elegant Krish Pata for various applications.' },
{ id: 432, name: 'KRISH PATA', category: 'Pata and Stools', img: Pimg32, productName: 'PATA & STOOL ALL PRODUCT', description: 'High-quality Krish Pata for home and office.' },
{ id: 433, name: 'KRISH PATA', category: 'Pata and Stools', img: Pimg33, productName: 'PATA & STOOL ALL PRODUCT', description: 'Sturdy and reliable Krish Pata.' },
{ id: 434, name: 'KRISH PATA', category: 'Pata and Stools', img: Pimg34, productName: 'PATA & STOOL ALL PRODUCT', description: 'Modern Krish Pata for multiple uses.' },


// Storage Organisers


{ id: 703, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg3, productName: 'HANGER' },

{ id: 706, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg6, productName: 'HANGER' },


{ id: 709, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg9, productName: 'HANGER' },
{ id: 710, name: 'Hanger (333)', category: 'Storage Organisers', img: Simg10, productName: 'HANGER' },
{ id: 711, name: 'Hanger (333)', category: 'Storage Organisers', img: Simg11, productName: 'HANGER' },
{ id: 712, name: 'Hanger (333)', category: 'Storage Organisers', img: Simg12, productName: 'HANGER' },
{ id: 713, name: 'Max Multi-Purpose Stand', category: 'Storage Organisers', img: Simg13, productName: 'Multi-purpose Stand' },
{ id: 714, name: 'Max Multi-Purpose Stand', category: 'Storage Organisers', img: Simg14, productName: 'Multi-purpose Stand' },
{ id: 715, name: 'Max Multi-Purpose Stand', category: 'Storage Organisers', img: Simg15, productName: 'Multi-purpose Stand' },
{ id: 716, name: 'Max Multi-Purpose Stand', category: 'Storage Organisers', img: Simg16, productName: 'Multi-purpose Stand' },
{ id: 717, name: 'HUMSAFAR BASKET', category: 'Storage Organisers', img: Simg17, productName: 'HUMSAFAR BASKET' },
{ id: 719, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg20, productName: 'Cane Multi Food Container' },
{ id: 720, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg21, productName: 'Cane Multi Food Container' },
{ id: 721, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg22, productName: 'Cane Multi Food Container' },
{ id: 722, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg23, productName: 'Cane Multi Food Container' },
{ id: 723, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg24, productName: 'Cane Multi Food Container' },
{ id: 724, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg25, productName: 'Cane Multi Food Container' },
{ id: 725, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg26, productName: 'Cane Multi Food Container' },
{ id: 726, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg27, productName: 'Cane Multi Food Container' },
{ id: 727, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg28, productName: 'Cane Multi Food Container' },
{ id: 728, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg29, productName: 'Cane Multi Food Container' },
{ id: 729, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg30, productName: 'Cane Multi Food Container' },
{ id: 730, name: 'all colors Cane Multi Food', category: 'Storage Organisers', img: Simg31, productName: 'Cane Multi Food Container' },
{ id: 731, name: 'Cane Multi Food Container', category: 'Storage Organisers', img: Simg19, productName: 'Cane Multi Food Container' },
{ id: 732, name: 'LAUNDRY BASKET ', category: 'Storage Organisers', img: Simg32, productName: 'LAUNDRY BASKET' },

{ id: 734, name: 'LAUNDRY BASKET', category: 'Storage Organisers', img: Simg34, productName: 'LAUNDRY BASKET' }, 
{ id: 735, name: 'LAUNDRY BASKET', category: 'Storage Organisers', img: Simg35, productName: 'LAUNDRY BASKET' },
{ id: 736, name: 'Multi-purpose Stand', category: 'Storage Organisers', img: Simg39, productName: 'Multi-purpose Stand' },
{ id: 737, name: 'Multi-purpose Stand', category: 'Storage Organisers', img: Simg36, productName: 'Multi-purpose Stand' },
{ id: 738, name: 'Multi-purpose Stand', category: 'Storage Organisers', img: Simg37, productName: 'Multi-purpose Stand' },
{ id: 739, name: 'Multi-purpose Stand', category: 'Storage Organisers', img: Simg38, productName: 'Multi-purpose Stand' },
{ id: 740, name: 'LAUNDRY BASKET', category: 'Storage Organisers', img: Simg40, productName: 'LAUNDRY BASKET' },
{ id: 741, name: 'LAUNDRY BASKET', category: 'Storage Organisers', img: Simg41, productName: 'LAUNDRY BASKET' },
{ id: 742, name: 'LAUNDRY BASKET', category: 'Storage Organisers', img: Simg42, productName: 'LAUNDRY BASKET' },
{ id: 743, name: 'HUMSAFAR BASKET', category: 'Storage Organisers', img: Simg43, productName: 'HUMSAFAR BASKET' },
{ id: 744, name: 'CYCLE BASKET', category: 'Storage Organisers', img: Simg44, productName: 'CYCKE BASKET' },
{ id: 745, name: 'CYCLE BASKET', category: 'Storage Organisers', img: Simg45, productName: 'CYCKE BASKET' },
{ id: 746, name: 'CYCLE BASKET', category: 'Storage Organisers', img: Simg46, productName: 'CYCKE BASKET' },
{ id: 747, name: 'KEEPER WHITE TRANSPARENT BOXES', category: 'Storage Organisers', img: Simg47, productName: 'KEEPER WHITE TRANSPARENT BOXES' },
{ id: 748, name: 'KEEPER WHITE TRANSPARENT BOXES', category: 'Storage Organisers', img: Simg48, productName: 'KEEPER WHITE TRANSPARENT BOXES' },

{ id: 750, name: 'KEEPER WHITE TRANSPARENT BOXES', category: 'Storage Organisers', img: Simg50, productName: 'KEEPER WHITE TRANSPARENT BOXES' },
{ id: 751, name: 'KEEPER WHITE TRANSPARENT BOXES', category: 'Storage Organisers', img: Simg51, productName: 'KEEPER WHITE TRANSPARENT BOXES' },
{ id: 752, name: 'KEEPER WHITE TRANSPARENT BOXES', category: 'Storage Organisers', img: Simg53, productName: 'KEEPER WHITE TRANSPARENT BOXES' },


{ id: 755, name: 'KEEPER WHITE TRANSPARENT BOXES', category: 'Storage Organisers', img: Simg56, productName: 'KEEPER WHITE TRANSPARENT BOXES' },

{ id: 757, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg58, productName: 'HANGER' },
{ id: 758, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg59, productName: 'HANGER' },
{ id: 759, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg60, productName: 'HANGER' },
{ id: 760, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg61, productName: 'HANGER' },
{ id: 761, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg62, productName: 'HANGER' },
{ id: 762, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg63, productName: 'HANGER' },
{ id: 763, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg64, productName: 'HANGER' },
{ id: 764, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg65, productName: 'HANGER' },
{ id: 765, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg66, productName: 'HANGER' },
{ id: 766, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg67, productName: 'HANGER' },
{ id: 767, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg68, productName: 'HANGER' },
{ id: 768, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg69, productName: 'HANGER' },
{ id: 769, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg70, productName: 'HANGER' },
{ id: 770, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg71, productName: 'HANGER' },
{ id: 771, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg72, productName: 'HANGER' },
{ id: 772, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg73, productName: 'HANGER' },
{ id: 773, name: 'Hanger (111)', category: 'Storage Organisers', img: Simg74, productName: 'HANGER' },
{ id: 774, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg75, productName: 'HANGER' },
{ id: 775, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg76, productName: 'HANGER' },
{ id: 776, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg77, productName: 'HANGER' },
{ id: 777, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg78, productName: 'HANGER' },
{ id: 778, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg79, productName: 'HANGER' },
{ id: 779, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg80, productName: 'HANGER' },
// { id: 780, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg81, productName: 'HANGER' },

{ id: 782, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg83, productName: 'HANGER' },
{ id: 783, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg84, productName: 'HANGER' },
{ id: 784, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg85, productName: 'HANGER' },
{ id: 785, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg86, productName: 'HANGER' },
{ id: 786, name: 'Hanger (222)', category: 'Storage Organisers', img: Simg87, productName: 'HANGER' },
{ id: 787, name: 'Hanger (333)', category: 'Storage Organisers', img: Simg88, productName: 'HANGER' },
{ id: 788, name: 'Hanger (333)', category: 'Storage Organisers', img: Simg89, productName: 'HANGER' },
{ id: 789, name: 'Hanger (333)', category: 'Storage Organisers', img: Simg90, productName: 'HANGER' },
{ id: 790, name: 'Hanger (333)', category: 'Storage Organisers', img: Simg91, productName: 'HANGER' },
{ id: 791, name: 'CYCLE BASKET', category: 'Storage Organisers', img: Simg92, productName: 'CYCKE BASKET' },
{ id: 792, name: 'CYCLE BASKET', category: 'Storage Organisers', img: Simg93, productName: 'CYCKE BASKET' },
{ id: 793, name: 'CYCLE BASKET', category: 'Storage Organisers', img: Simg94, productName: 'CYCKE BASKET' },
{ id: 794, name: 'HUMSAFAR Basket', category: 'Storage Organisers', img: Simg95, productName: 'HUMSAFAR BASKET' },
{ id: 795, name: 'HUMSAFAR Basket', category: 'Storage Organisers', img: Simg96, productName: 'HUMSAFAR BASKET' },
  
  
  


// Cleaning Utilities com
{ id: 601, name: 'JALI DUSTBIN', category: 'Cleaning Utilities', img: Cimg1, productName: 'DOMES & DUSTBIN' },
  { id: 602, name: 'PLAIN DUSTBIN', category: 'Cleaning Utilities', img: Cimg2, productName: 'DOMES & DUSTBIN' },
  { id: 603, name: 'PLAIN DUSTBIN', category: 'Cleaning Utilities', img: Cimg3, productName: 'DOMES & DUSTBIN' },
  { id: 604, name: 'PLAIN DUSTBIN', category: 'Cleaning Utilities', img: Cimg4, productName: 'DOMES & DUSTBIN' },
  { id: 605, name: 'Dc Dustbin', category: 'Cleaning Utilities', img: Cimg5, productName: 'DOMES & DUSTBIN' },
  { id: 606, name: 'JALI DUSTBIN', category: 'Cleaning Utilities', img: Cimg6, productName: 'DOMES & DUSTBIN' },
  { id: 607, name: 'JALI DUSTBIN', category: 'Cleaning Utilities', img: Cimg7, productName: 'DOMES & DUSTBIN' },
  { id: 608, name: 'JALI DUSTBIN', category: 'Cleaning Utilities', img: Cimg8, productName: 'DOMES & DUSTBIN' },
  { id: 609, name: 'MINI SWING BIN', category: 'Cleaning Utilities', img: Cimg9, productName: 'DOMES & DUSTBIN' },
  { id: 610, name: 'MINI SWING BIN', category: 'Cleaning Utilities', img: Cimg10, productName: 'DOMES & DUSTBIN' },
  { id: 611, name: 'ROUND SWING BIN', category: 'Cleaning Utilities', img: Cimg11, productName: 'DOMES & DUSTBIN' },
  { id: 612, name: 'ROUND SWING BIN', category: 'Cleaning Utilities', img: Cimg12, productName: 'DOMES & DUSTBIN' },
  { id: 613, name: 'ROUND SWING BIN', category: 'Cleaning Utilities', img: Cimg13, productName: 'DOMES & DUSTBIN' },
  { id: 614, name: 'ROUND SWING BIN', category: 'Cleaning Utilities', img: Cimg14, productName: 'DOMES & DUSTBIN' },
  { id: 615, name: 'ROUND SWING BIN', category: 'Cleaning Utilities', img: Cimg15, productName: 'DOMES & DUSTBIN' },
  { id: 616, name: 'SQUARE SWING BIN', category: 'Cleaning Utilities', img: Cimg16, productName: 'DOMES & DUSTBIN' },
  { id: 617, name: 'SQUARE SWING BINS', category: 'Cleaning Utilities', img: Cimg17, productName: 'DOMES & DUSTBIN' },
  { id: 618, name: 'SQUARE SWING BINS', category: 'Cleaning Utilities', img: Cimg18, productName: 'DOMES & DUSTBIN' },
  { id: 619, name: 'pedal bin', category: 'Cleaning Utilities', img: Cimg19, productName: 'DOMES & DUSTBIN' },
  { id: 620, name: 'pedal bin', category: 'Cleaning Utilities', img: Cimg20, productName: 'DOMES & DUSTBIN' },
  { id: 621, name: 'pedal bin', category: 'Cleaning Utilities', img: Cimg21, productName: 'DOMES & DUSTBIN' },
  { id: 622, name: 'pedal bin', category: 'Cleaning Utilities', img: Cimg22, productName: 'DOMES & DUSTBIN' },
  { id: 623, name: 'SQUARE DOME', category: 'Cleaning Utilities', img: Cimg23, productName: 'DOMES & DUSTBIN' },
  { id: 624, name: 'SQUARE DOME', category: 'Cleaning Utilities', img: Cimg24, productName: 'DOMES & DUSTBIN' },
  { id: 625, name: 'SQUARE DOME', category: 'Cleaning Utilities', img: Cimg25, productName: 'DOMES & DUSTBIN' },
  { id: 626, name: 'SQUARE DOME', category: 'Cleaning Utilities', img: Cimg26, productName: 'DOMES & DUSTBIN' },
  { id: 627, name: 'SQUARE DOME', category: 'Cleaning Utilities', img: Cimg27, productName: 'DOMES & DUSTBIN' },
  { id: 628, name: 'SQUARE DOME', category: 'Cleaning Utilities', img: Cimg28, productName: 'DOMES & DUSTBIN' },
  { id: 629, name: 'ROUND DRUMS', category: 'Cleaning Utilities', img: Cimg29, productName: 'DRUMS' },
  { id: 630, name: 'ROUND DRUMS', category: 'Cleaning Utilities', img: Cimg30, productName: 'DRUMS' },
  { id: 631, name: 'ROUND DRUMS', category: 'Cleaning Utilities', img: Cimg31, productName: 'DRUMS' },
  { id: 632, name: 'ROUND DRUMS', category: 'Cleaning Utilities', img: Cimg32, productName: 'DRUMS' },
  { id: 633, name: 'DUSTPANS', category: 'Cleaning Utilities', img: Cimg33, productName: 'DUSTPAN' },
  { id: 634, name: 'DUSTPANS', category: 'Cleaning Utilities', img: Cimg35, productName: 'DUSTPAN' },
  { id: 635, name: 'DUSTPANS', category: 'Cleaning Utilities', img: Cimg36, productName: 'DUSTPAN' },
  { id: 636, name: 'DUSTPANS', category: 'Cleaning Utilities', img: Cimg38, productName: 'DUSTPAN' },
  { id: 637, name: 'DUSTPANS', category: 'Cleaning Utilities', img: Cimg37, productName: 'DUSTPAN' },
  { id: 638, name: 'DUSTPANS', category: 'Cleaning Utilities', img: Cimg34, productName: 'DUSTPAN' },




























];

function ProductCC() {
    const { productName } = useParams();
  const [searchQuery, setSearchQuery] = useState(''); 

  const categoryProducts = products.filter(
    product =>
      product.productName === productName &&
      product.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="CategoryPage">
      <div className='uper'>
        <h1>{productName}</h1>
      </div>
      <div className='main'>
        <div className="filters">
          <div className='input_section'>
            <input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
            <div className='icons'>
              <FontAwesomeIcon className='icon' color='#ffff' icon={faSearch} />
            </div>
          </div>
          <h4>PRODUCT CATEGORIES</h4>
          <select onChange={e => setSearchQuery(e.target.value)}>
            <option value="">All</option>
            {categories.map(category => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>
        <div className="product-list">
          {categoryProducts.map(product => (
            <div key={product.name} className="product-item">
              <Link to={`/product/${product.id}`}>
                {product.img && <img src={product.img} alt={product.name} />}
               {/*.<h1>{product.name}</h1>.*/}
                <h2>{product.name}</h2>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProductCC;
